import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrl: './terms-dialog.component.scss'
})
export class TermsDialogComponent {
  constructor(private dialogRef: MatDialogRef<TermsDialogComponent>) { }

  onAccept(): void {
    this.dialogRef.close(true); // Chiude il dialog e ritorna "true"
  }

  onDecline(): void {
    this.dialogRef.close(false); // Chiude il dialog e ritorna "false"
  }
}
